import { INITIAL_INSIGHTS_STATE } from './insights/survey-creation-insights-state.constants';
import {
  EMPTY_ADVANCED_FEASIBILITY_FILTERS,
  INITIAL_LOCATION_UPLOAD_STATE,
} from '@ps/survey-utils';

import {
  QuestionCategoriesState,
  SurveyCreationAudienceState,
  SurveyCreationReferenceState,
  SurveyCreationState,
  SurveyTagLinkState,
} from './survey-creation-state.model';
import { SuppliersMetaData } from './audience/survey-creation-suppliers-meta-data-state.model';

export const INITIAL_QUESTION_CATEGORIES_STATE: QuestionCategoriesState = {
  data: [],
  cachedAt: null,
  loading: false,
};

export const INITIAL_TAG_LINK_STATE: SurveyTagLinkState = {
  linkedTagIds: [],
  linkTagsError: null,
};

export const INITIAL_SUPPLIERS_META_DATA_STATE: SuppliersMetaData = {
  blendId: '',
};

export const INITIAL_SURVEY_CREATION_AUDIENCE_STATE: SurveyCreationAudienceState =
  {
    surveyId: null,
    survey: null,
    error: null,
    metadata: { value: null, valid: false, errors: [], isDirty: false },
    qualifications: { value: [], valid: true, errors: [], isDirty: false },
    quotas: { value: [], valid: true, errors: [], isDirty: false },
    locationFileUpload: { ...INITIAL_LOCATION_UPLOAD_STATE },
    advancedFeasibilityFilters: { ...EMPTY_ADVANCED_FEASIBILITY_FILTERS },
    tagLinks: { ...INITIAL_TAG_LINK_STATE },
    suppliersMetaData: { ...INITIAL_SUPPLIERS_META_DATA_STATE },
  };

export const INITIAL_SURVEY_CREATION_REFERENCE_STATE: SurveyCreationReferenceState =
  {
    qualificationsRecord: {},
    questionCategories: { ...INITIAL_QUESTION_CATEGORIES_STATE },
    questionsRecord: {},
    questionsLoadingKey: null,
    locationConditionsRecord: {},
    locationConditionsLoadingKey: null,
  };

export const INITIAL_SURVEY_CREATION_STATE: SurveyCreationState = {
  audience: { ...INITIAL_SURVEY_CREATION_AUDIENCE_STATE },
  insights: { ...INITIAL_INSIGHTS_STATE },
  reference: { ...INITIAL_SURVEY_CREATION_REFERENCE_STATE },
};
